









































































import Vue from 'vue'
import Component from 'vue-class-component'
import { MediaObject } from '@/modules/media/types'
import { State } from 'vuex-class'
import MediaDetail from '@/modules/media/components/MediaDetail.vue'

/**
 * Visor multimedia
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        'metadata-info': MediaDetail,
    },
})
export default class MediaViewer extends Vue {
    public $refs: Vue['$refs'] & {
        video?: HTMLVideoElement,
    }

    @State(state => state.media.currentMedia)
    public currentMedia: MediaObject

    public tag = 0

    /**
     * Url del archivo multimedia
     *
     * Incluye en la URL una query con la fecha de última modificación. Esto permite
     * al navegador obtener el recurso siempre actualizado
     *
     * @return { string }
     */
    public get mediaURL (): string {
        return `${this.currentMedia.url}?t=${this.currentMedia.updateAt.getTime() / 1000}`
    }

    /**
     * Cierra el visor multimedia y libera los recursos
     */
    public close () {
        // Solicita al componente padre, que controla la visibilidad del componente, que
        // deje de mostrarlo
        this.$emit('close', true)

        if (this.currentMedia.isVideo && !!this.$refs.video) {
            // Para eliminar un video de forma segura, sin errores
            // https://stackoverflow.com/questions/3258587/how-to-properly-unload-destroy-a-video-element
            this.$refs.video!.pause()
            this.$refs.video!.removeAttribute('src')
            this.$refs.video!.load()
        }
    }

    /**
     * Permite obtener el nombre del icono que será mostrado para representar
     * el tipo del icono
     */
    public get icon () {
        switch (true) {
            case this.currentMedia.isImage:
                return 'photo'
            case this.currentMedia.isPDF:
                return 'mdi-file-outline'
            case this.currentMedia.isVideo:
                return 'mdi-video'
            default:
                return 'mdi-file'
        }
    }
}
